import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { RestaurantContext } from '../../RestaurantDesignerHandler'
import { ExpandableBlocks } from 'components/ContentBlock'
import FormBlock from './FormBlock'
import { INTERIOR_TYPE, TABLE_TYPE, WALL_TYPE } from './consts'

const FurnitureCreator = ({ mutations }) => {
	const { shapeCreatorType, setShapeCreatorType } = useContext(RestaurantContext)
	const [t] = useTranslation()
	return (
		<ExpandableBlocks expandedId={shapeCreatorType} defaultExpandedId={'table'} onExpand={setShapeCreatorType}>
			<FormBlock startExpanded label={t('restaurant_designer_section.strings.item_creator_tables_title')} type={TABLE_TYPE} mutations={mutations}/>
			<FormBlock label={t('restaurant_designer_section.strings.item_creator_interiors_title')} type={WALL_TYPE} mutations={mutations} />
			<FormBlock label='Innenausstattung' type={INTERIOR_TYPE} mutations={mutations} />
		</ExpandableBlocks>
	)
}

export default FurnitureCreator

